import { html } from '@dom'

function component() {
  return html`
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="93" viewBox="0 0 60 93">
      <path d="M18.25 92.25H0V29.75C0 22.75 1.29167 17.0417 3.875 12.625C6.41667 8.25 9.9375 5.04167 14.4375 3C18.9375 1 24.0833 0 29.875 0C35.7083 0 40.8958 1 45.4375 3C49.9792 5.04167 53.5208 8.25 56.0625 12.625C58.5625 17.0417 59.8125 22.75 59.8125 29.75V92.25H41.5625V29.75C41.5625 25.7917 41.125 22.75 40.25 20.625C39.3333 18.5 38.0208 17.0417 36.3125 16.25C34.5625 15.5 32.4167 15.125 29.875 15.125C27.2917 15.125 25.1667 15.5 23.5 16.25C21.7917 17.0417 20.5 18.5 19.625 20.625C18.7083 22.75 18.25 25.7917 18.25 29.75V92.25Z" fill="currentColor"/>
    </svg>
  `
}

export default component
